import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { common } from '../constants/common';
import { useNavigate } from 'react-router-dom';


const ServiceCard = ({ id, title, description, delay }) => {

    const navigate = useNavigate();

    const renderService = (id) =>{
        navigate(`/service/${id}`);
    }
    return(
        <Grid item xs={12} md={6} lg={4} key={id}>
            <Card className='service-card' >
                <CardContent>
                    <Typography onClick={()=>{renderService(id)}} variant="h6" className='service-title'>{title}</Typography>
                    <Typography variant="body1" color="textSecondary" className="service-description">
                        {description}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
};

const Services = () => {
  return (
    <Box id="services" className="services">
      <Container>
            <Typography variant="h4" className="section-title" data-aos="fade-up">
                Our Services
            </Typography>
            <Grid container spacing={4} className="service-grid" sx={{ marginTop: '30px' }}>
                {
                    common?.services.map((service, index) => {
                        return <ServiceCard key={index} id={service.id} title={service.title} description={service.description} delay={service.delay} />
                    })
                }
            </Grid>
      </Container>
    </Box>
  );
};

export default Services;
